import React, { useContext, useEffect, useState } from 'react';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import RichTextComp from '../../MySections/TextEditor/RichText';
import SectItmmainHeadEffects from './SectItmmainHeadEffects';
import SectItmSmalltxtEffects from './SectItmSmalltxtEffects';
import SetItemSmalltxtBlock from './SetItemSmalltxtBlock';
import SetItemSmalltxtef from './SetItemSmalltxtef';

const SectionContact = (props) => {

    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);


    const [mainHead, setMainHead] = useState(currentSingle.contactBlocksHead_Text);
    const [smalltxt, setSmalltxt] = useState(currentSingle.smalltxt);
    const [switchesBlocks, setSwitchesBlocks] = useState([]);
    
    const [blockColor, setBlockColor] = useState(currentSingle.blockColor);
    const [blockLeft, setBlockLeft] = useState(currentSingle.blockLeft);
    const [blockTop, setBlockTop] = useState(currentSingle.blockTop);
    const [blockTransparent, setBlockTransparent] = useState(currentSingle.blockTransparent);
    const [blockWidth, setBlockWidth] = useState(currentSingle.blockWidth);
    const [blockHeight, setBlockHeight] = useState(currentSingle.blockHeight);

    useEffect(() => {
        setTheswitchesBlocks();
    }, [])



    const setTheswitchesBlocks = () => {

        let theLst;
        if (currentSingle.contactBlocksDisp?.length > 0) {
            theLst = currentSingle.contactBlocksDisp.map((itm, indx) => {
                return (
                    <SwitchItem key={indx} itm={itm} setTheswitchesBlocks={() => setTheswitchesBlocks()} />
                )
            })
        }
        else {
            currentSingle.contactBlocksDisp = [
                { name: "שם פרטי", checked: true },
                { name: "שם משפחה", checked: true },
                { name: "טלפון", checked: true },
                { name: "אימייל", checked: true },
                { name: "תוכן הודעה", checked: true }
            ]

            theLst = currentSingle.contactBlocksDisp.map((itm, indx) => {
                return (
                    <SwitchItem key={indx} itm={itm} setTheswitchesBlocks={() => setTheswitchesBlocks()} />
                )
            })
        }

        setSwitchesBlocks(theLst)
    }

    return (
        <>
            <div className="form-row tabsInputs ">
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>רוחב קובייה (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"50"} value={blockWidth} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockWidth = e.target.value; setBlockWidth(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>גובה קובייה (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"50"} value={blockHeight} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockHeight = e.target.value; setBlockHeight(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>צבע רקע קובייה</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"#fffff"} value={blockColor} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockColor = e.target.value; setBlockColor(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>מיקום משמאל (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"25"} value={blockLeft} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockLeft = e.target.value; setBlockLeft(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>מיקום מלמעלה (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"25"} value={blockTop} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockTop = e.target.value; setBlockTop(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>שקיפות (0.1 - 1)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"0.7"} value={blockTransparent} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockTransparent = e.target.value; setBlockTransparent(e.target.value) }} />

                    </div>
                </div>

            </div>
            <div className="form-row tabsInputs ">

                <div className={"col-md-9 mb-2 onRight"}>
                    <label htmlFor={"validationCustom01"}>כותרת ראשית</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom01"} placeholder={"כותרת ראשית"}
                            value={mainHead}
                            onChange={(e) => { currentSingle.contactBlocksHead_Text = e.target.value ;setMainHead(e.target.value)}} required />

                    </div>
                </div>
                <SetItemSmalltxtef
                    delay={"contactBlocksHead_delay"}
                    duration={"contactBlocksHead_duration"}
                    txtColor={"contactBlocksHead_txtColor"}
                    effect={"contactBlocksHead_effect"}
                    thePage={currentSingle} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />
            </div>

            <div className="form-row tabsInputs ">

                <div className={"col-md-9 mb-2 onRight"}>

                    <label htmlFor={"validationCustom03"}>פרטים מבוקשים</label>
                    <div className={"input-group"}>
                        {switchesBlocks}
                    </div>
                </div>

                <div className={"col-md-3 mb-2 onRight"}>
                    <SetItemSmalltxtBlock thePage={currentSingle}
                        attrName={"contactBlocksTxtColor"}
                        headTxt={"צבע טקסט"}
                        placeholde={"#fffff"}

                        theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />

                    <SetItemSmalltxtBlock thePage={currentSingle}
                        attrName={"contactBlocksTxtBgColor"}
                        headTxt={"רקע טקסט"}
                        placeholde={"#fffff"}
                        theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />
                </div>
            </div>
            <div className="form-row tabsInputs ">

                <div className={"col-md-9 mb-2 onRight"}>

                    <label htmlFor={"validationCustom03"}>טקסט פתיחה</label>
                    <div className={"input-group"}>
                        <RichTextComp firstText={currentSingle.contactBlocksStart_Text}
                            saveEditorTxt={(content) => { currentSingle.contactBlocksStart_Text = content }} />
                    </div>
                </div>
                <SetItemSmalltxtef
                    delay={"contactBlocksStart_delay"}
                    duration={"contactBlocksStart_duration"}
                    txtColor={"contactBlocksStart_txtColor"}
                    effect={"contactBlocksStart_effect"}

                    thePage={currentSingle} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />
            </div>

            <div className="form-row tabsInputs ">

                <div className={"col-md-9 mb-2 onRight"}>

                    <label htmlFor={"validationCustom03"}>טקסט סיום</label>
                    <div className={"input-group"}>
                        <RichTextComp firstText={currentSingle.contactBlocksEnd_Text}
                            saveEditorTxt={(content) => { currentSingle.contactBlocksEnd_Text = content; }} />
                    </div>
                </div>
                <SetItemSmalltxtef
                    delay={"contactBlocksEnd_delay"}
                    duration={"contactBlocksEnd_duration"}
                    txtColor={"contactBlocksEnd_txtColor"}
                    effect={"contactBlocksEnd_effect"}

                    thePage={currentSingle} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />
            </div>


        </>


    );
}

const SwitchItem = (props) => {
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);

    const checkdCh = (itm) => {
        itm.checked = !itm.checked;
        let indxx = currentSingle.contactBlocksDisp.findIndex(it => it.name == itm.name);

        currentSingle.contactBlocksDisp[indxx] = itm;

        props.setTheswitchesBlocks();
    }

    return (
        <div className={"col-md-3 mb-2"}>
            <label className="ms-switch">
                <input type="checkbox" id={"validationCustom5_3"} checked={props.itm.checked}
                    onChange={() => {
                        checkdCh(props.itm)
                    }} />
                <span className="ms-switch-slider ms-switch-primary round" />
            </label> <span className={"spHead"}>{props.itm.name}</span>
        </div>
    )
}

export default SectionContact;


